module.exports = __webpack_public_path__ + "static/media/regular.499177ab.ttf";